import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { queryClient } from '../../queryClient';
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { PersonRegular, SignOutRegular } from '@fluentui/react-icons';
import { signOut } from '../../services/signOut';

/**
 * The account menu, at the right end of the header: who is signed in, and Sign out (`services/signOut.ts`). There was no
 * way to sign out of this app until 2026-10-28, so a shared machine stayed signed in as whoever used it last.
 */
export default function AccountMenu() {
  const { t } = useTranslation();
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const name = account?.name || account?.username || '';

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button appearance="transparent" className="app-header-account" icon={<PersonRegular />} aria-label={t('account.menuLabel')}>
          {name}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {account?.username && <MenuItem disabled>{t('account.signedInAs', { name: account.username })}</MenuItem>}
          <MenuItem icon={<SignOutRegular />} onClick={() => void signOut(instance, queryClient)}>
            {t('account.signOut')}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
